/**
 * The `compose.reply` pill arg naming the conversation a reply button was built for.
 *
 * Office.js can only reply to the item that is open RIGHT NOW (`displayReplyForm`
 * takes no id), and pills stay in the transcript forever. A button from an
 * earlier turn, clicked after the user moved to another thread, would otherwise
 * write that turn's text into the wrong one — spec §4.3: "a stale context is how
 * 'reply to this' replies to the wrong email".
 *
 * The value is the open item's Graph REST conversation id when the turn STARTED
 * (`MailboxItem.conversationId`), stamped onto every reply pill the turn emits.
 *
 * Conversation, not message: another message in the SAME thread is still the
 * right place for the reply. That is what the subject check this sits beside has
 * always accepted ("Re:" stripped), and DR-01 frames a reply by its
 * `conversationId`. Matching the exact message refused a reply-all on the
 * original of a thread whose latest reply the turn had run on.
 *
 * A module of its own, with no imports, so both the pill side (src/chat) and the
 * handler side (integrations/tools/outlook) can share the name without either
 * importing the other.
 */
export const REPLY_TARGET_CONVERSATION_ARG = "reply_to_conversation_id";
